import { useEffect, useState } from "react";
import React from "react";

import { isDefined } from "@utils/helpers";

import { useLanguage } from "@context/language.context";

type StoreDistanceComponentProps = {
    distancePromise: Promise<undefined | number>;
};

export const formatDistance = (
    distance: number | undefined,
    getLocale: (getShortVersion: boolean) => string,
) => {
    if (!isDefined(distance)) return;

    const locale = getLocale(false).replace("_", "-");

    // Distance in metres -> Convert to km and round to .1
    const roundedDistance = Math.round(distance / 100) / 10;

    const localizedDistance = new Intl.NumberFormat(locale, {
        useGrouping: false,
    }).format(roundedDistance);

    return `${localizedDistance} km`;
};

export const StoreDistanceComponent = ({
    distancePromise,
}: StoreDistanceComponentProps) => {
    const [distance, setDistance] = useState<undefined | number>(undefined);
    const { getLocale } = useLanguage();

    useEffect(() => {
        if (!distancePromise) return;
        distancePromise.then(setDistance, getLocale);
    }, [distancePromise]);

    const formattedDistance = formatDistance(distance, getLocale);

    if (!isDefined(distance)) return null;

    return (
        <span className={"font-weight-normal small ml-3"}>
            {formattedDistance}
        </span>
    );
};
